<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Firewall</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <h5>Banned IPs</h5>
        <div class="input-group">
            <input type="text" class="form-control" v-model="searchBannedIp" placeholder="IP to check" aria-label="IP to check" aria-describedby="basic-addon2">
            <div class="input-group-append">
                <button class="btn btn-hub-primary" type="button" @click="getBannedIp(searchBannedIp)"><i class="fa fa-search"></i> Search</button>
                <button class="btn btn-danger" type="button" v-show="banned_ip.ip != null && !banned_ip.is_banned" @click="banIp"><i class="fa fa-ban"></i> Ban</button>
                <button class="btn btn-success" type="button" v-show="banned_ip.ip != null && banned_ip.is_banned" @click="unBanIp"><i class="fa fa-check"></i> Unban</button>
            </div>
        </div>
        <small class="form-text text-muted" v-show="banned_ip.ip != null">
            This IP is {{ banned_ip.is_banned ? 'banned' : 'not banned' }}
        </small>
      </div>
    </div>
    <br><br>
    <div class="row">
        <div class="col-8">
            <h5>Ignored IPs</h5>
            <div class="input-group">
                <input type="text" class="form-control" v-model="ignoreIpToAdd" placeholder="IP to add" aria-label="IP to check" aria-describedby="basic-addon2">
                <div class="input-group-append">
                    <button class="btn btn-success" type="button" @click="ignoreIp(ignoreIpToAdd)"><i class="fa fa-edit"></i> Add</button>
                </div>
            </div>
            <br>
            <table class="table table-striped">
                <thead class="bg-hub-primary text-white">
                    <tr>
                        <th>IP</th>
                        <th v-if="[3, 4].includes(logged_in_user.group_id)">Manage</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ignored_ip in ignored_ips" :key="ignored_ip">
                        <td>{{ ignored_ip }}</td>
                        <td v-if="[3, 4].includes(logged_in_user.group_id)">
                            <button type="button" class="btn btn-danger" @click="unIgnoreIp(ignored_ip)"><i
                                class="fa fa-trash fa-fw" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      searchBannedIp: '',
      ignoreIpToAdd: ''
    }
  },
  computed: mapGetters({
    logged_in_user: 'loggedInUser',
    ignored_ips: 'allIgnoredIps',
    banned_ip: 'bannedIp'
  }),
  methods: mapActions([
    'getBannedIp',
    'banIp',
    'unBanIp',
    'ignoreIp',
    'unIgnoreIp'
  ]),
  created () {
    this.$store.dispatch('getIgnoredIps')
  },
  beforeDestroy () {
    this.$store.dispatch('clearBannedIp')
  }
}
</script>

<style scoped>

</style>
